import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import * as I from 'core/api/coreApiClient';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatCommandUrl } from 'core/utilities/command/command';
import type React from 'react';
import { useSelector } from 'react-redux';

function ItemExternalLink({
  item, buttonRef, onClose, selected,
}: ItemComponentProps) {
  const {
    id, title, active, commandType,
  } = item;

  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        data-e2e-dropdown-item={id}
        href={formatCommandUrl(jsfUrl, item)}
        target={commandType === I.CommandTypeConstants.JSFHREF ? '_self' : '_blank'}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          onClose(e, buttonRef);
        }}
        dense
        disabled={active === false}
        component={Link}
        role="link"
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
    </li>
  );
}

export default ItemExternalLink;
